import React from 'react';
import Button from 'components/Buttons/Button/Button';
import translate from '../../utils/fnTranslate';
import { SubscriptionErrorWrapper, SubscriptionErrorTitle, SubscriptionErrorBody } from './SubscriptionErrorScreen.css';
import { useAuth } from '../../providers/useAuth/AuthContext';

interface SubscriptionErrorScreenProps {
    onRetry?: () => void;
}

export const SubscriptionErrorScreen: React.FC<SubscriptionErrorScreenProps> = () => {
    const { logUserOut } = useAuth();

    const handleReLogin = () => {
        logUserOut(true);
    };

    return (
        <SubscriptionErrorWrapper>
            <SubscriptionErrorTitle>{translate('NOTIFICATION_NO_PRODUCTS_TITLE')}</SubscriptionErrorTitle>
            <SubscriptionErrorBody>{translate('NOTIFICATION_NO_PRODUCTS_BODY')}</SubscriptionErrorBody>
            <Button isPrimary={true} label={translate('OK_BUTTON')} onClick={handleReLogin} />
        </SubscriptionErrorWrapper>
    );
};
